import { render, staticRenderFns } from "./NavVerticalCE.vue?vue&type=template&id=5efa6d74&scoped=true"
import script from "./NavVerticalCE.vue?vue&type=script&lang=js"
export * from "./NavVerticalCE.vue?vue&type=script&lang=js"
import style0 from "./NavVerticalCE.vue?vue&type=style&index=0&id=5efa6d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa6d74",
  null
  
)

export default component.exports